export enum SituacaoUsuarioNoProvedor {
  Disponivel = 'Disponivel',
  JaCadastradoNoHorus = 'JaCadastradoNoHorus',
  InativoNoProvedor = 'InativoNoProvedor',

  NaoExisteNoProvedor = 'NaoExisteNoProvedor',
}
